import slugify from "slugify";

export default function slug(string = "") {
    return slugify(string, {
        lower: true,
        trim: true,
        // remove: /[^\w\d\-\s]/i,
        strict: true,
    });
}
